import z from "zod";
import { timestampsSchema } from "../helpers";
import { localeSchema } from "./locale.schema";
export var UserRoleEnum;
(function (UserRoleEnum) {
    UserRoleEnum["USER"] = "USER";
    UserRoleEnum["SUPER_ADMIN"] = "SUPER_ADMIN";
})(UserRoleEnum || (UserRoleEnum = {}));
export var OrgMemberRoleEnum;
(function (OrgMemberRoleEnum) {
    OrgMemberRoleEnum["OWNER"] = "OWNER";
    OrgMemberRoleEnum["ADMIN"] = "ADMIN";
    OrgMemberRoleEnum["MEMBER"] = "MEMBER";
})(OrgMemberRoleEnum || (OrgMemberRoleEnum = {}));
export const sessionRoleSchema = z.union([
    z.nativeEnum(OrgMemberRoleEnum),
    z.literal(UserRoleEnum.SUPER_ADMIN),
]);
export const userSchema = z.object({
    id: z.number(),
    username: z.string(),
    email: z.email(),
    fullName: z.string(),
    locale: localeSchema.nullable(),
    ...timestampsSchema
});
//# sourceMappingURL=users.schema.js.map